import { Link } from "react-router-dom";
import { Button, Form } from "antd";
import { EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";
import ControlledInputBox from "../../components/ControlledInputBox";
import logoSvg from "./logo_alt.svg";
import "./style.css";
import { useState,React } from "react";
/* const styles = {
  loginFormContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
  },
  loginForm: {
    display: "flex",
    flexDirection: "column",
    width: "30vw",
    border: "2px solid #f3f4f5",
    padding: 30,
    paddingTop: 20,
    borderRadius: 4,
  },
  heading: {
    fontFamily: "'B612', open-sans",
    fontSize: 32,
    marginBottom: 15,
    color: "#0a8080",
  },
}; */

const LoginForm = ({ onSubmit, loading, control, errors }) => {
 const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  return (
    <div className="loginFormContainer">
      <Form colon={false}>
        <div className="loginForm">
          <div
            style={{ borderBottom: "2px dashed #f3f4f5", marginBottom: "15px" }}
          >
            <p className="heading">
              <img
                src={logoSvg}
                alt="Logo"
                style={{ height: "32px", width: "auto", cursor: "pointer" }}
              />
            </p>
          </div>
          <ControlledInputBox
            required
            control={control}
            errors={errors}
            name="username"
            placeholder="name@example.com"
            label="Your Email"
          />
          <div style={{ position: "relative" }}>
            <ControlledInputBox
              type={showPassword ? "text" : "password"}
              required
              control={control}
              errors={errors}
              name="password"
              placeholder="Super secret password"
              label="Your Password"
            />
            <Button
              type="text"
              icon={showPassword ? <EyeInvisibleOutlined /> : <EyeOutlined />}
              onClick={togglePasswordVisibility}
              style={{
                position: "absolute",
                right: "8px",
                top: "47px",
                transform: "translateY(-50%)",
                border: "none",
                background: "transparent",
                color: "#8c8c8c",
                zIndex: 1,
              }}
              aria-label={showPassword ? "Hide password" : "Show password"}
            />
          </div>
          <Button
            type="primary"
            size="large"
            disabled={loading}
            loading={loading}
            onClick={onSubmit}
          >
            Login
          </Button>
          <div style={{ padding: "20px 0 0 0", textAlign: "center" }}>
            <Link to="/recovery">Forgot Password?</Link>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default LoginForm;
